/**
 * Custom JavaScript for Dragonfly Brand
 * Mobile text switching for add to cart and checkout buttons
 */

document.addEventListener('DOMContentLoaded', function() {
  // Debounce function to limit resize event firing
  function debounce(func, wait) {
    var timeout;
    return function executedFunction() {
      var later = function() {
        clearTimeout(timeout);
        func();
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Mobile text switching for add to cart and checkout buttons
  function mobileTextSwitcher() {
    var isMobile = window.matchMedia('(max-width: 769px)').matches;
    
    // Handle add to cart buttons
    var addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
    addToCartButtons.forEach(function(button) {
      var desktopText = button.querySelector('.add-to-cart-text--desktop');
      var mobileText = button.querySelector('.add-to-cart-text--mobile');
      
      if (desktopText && mobileText) {
        if (isMobile) {
          desktopText.style.display = 'none';
          mobileText.style.display = 'inline';
        } else {
          desktopText.style.display = 'inline';
          mobileText.style.display = 'none';
        }
      }
    });
    
    // Handle checkout buttons
    var checkoutButtons = document.querySelectorAll('[data-mobile-text]');
    checkoutButtons.forEach(function(button) {
      var desktopText = button.querySelector('.checkout-text--desktop');
      var mobileText = button.querySelector('.checkout-text--mobile');
      
      if (desktopText && mobileText) {
        if (isMobile) {
          desktopText.style.display = 'none';
          mobileText.style.display = 'inline';
        } else {
          desktopText.style.display = 'inline';
          mobileText.style.display = 'none';
        }
      }
    });
  }

  // Initialize mobile text switching
  mobileTextSwitcher();
  
  // Debounced resize handler for better performance
  var debouncedSwitcher = debounce(mobileTextSwitcher, 150);
  
  // Update on window resize (debounced)
  window.addEventListener('resize', debouncedSwitcher);
  
  // Use MediaQuery listener for more efficient breakpoint detection
  var mediaQuery = window.matchMedia('(max-width: 769px)');
  mediaQuery.addListener(function(e) {
    mobileTextSwitcher();
  });
  
  // Also run after page loads (for dynamically loaded content)
  document.addEventListener('page:loaded', mobileTextSwitcher);
  
  // Run on orientation change for mobile devices
  window.addEventListener('orientationchange', function() {
    setTimeout(mobileTextSwitcher, 100);
  });
});

/**
 * Lightweight product availability override.
 * Impulse updates its native inventory UI first, then emits variant:change.
 * We only replace the message for sellable Shopify-tracked variants at quantity <= 0.
 */
(function() {
  function findProductIdForVariant(variantId) {
    var id = String(variantId);
    var inventories = window.inventories || {};

    for (var productId in inventories) {
      if (!Object.prototype.hasOwnProperty.call(inventories, productId)) continue;
      if (inventories[productId] && Object.prototype.hasOwnProperty.call(inventories[productId], id)) {
        return String(productId);
      }
    }

    var variantData = document.querySelector('.js-variant-inventory-data[data-id="' + id + '"]');
    if (variantData) {
      var inventoryData = variantData.closest('.js-product-inventory-data');
      if (inventoryData && inventoryData.dataset.productId) {
        return String(inventoryData.dataset.productId);
      }
    }

    return null;
  }

  function getInventoryRecord(productId, variantId) {
    var inventories = window.inventories || {};
    var productInventory = inventories[productId];
    if (productInventory && productInventory[variantId]) {
      return productInventory[variantId];
    }

    var inventoryDataBlocks = document.querySelectorAll('.js-product-inventory-data[data-product-id="' + productId + '"]');
    for (var i = 0; i < inventoryDataBlocks.length; i++) {
      var variantData = inventoryDataBlocks[i].querySelector('.js-variant-inventory-data[data-id="' + variantId + '"]');
      if (variantData) {
        return {
          quantity: variantData.dataset.quantity,
          policy: variantData.dataset.policy,
          incoming: variantData.dataset.incoming,
          next_incoming_date: variantData.dataset.date
        };
      }
    }

    return null;
  }

  function inventoryBelongsToSelectedVariant(inventoryElement, variantId) {
    var productSection = inventoryElement.closest('.product-section');
    if (!productSection) return true;

    var variantInput = productSection.querySelector('select[name="id"], input[name="id"]');
    if (!variantInput) return true;

    return String(variantInput.value) === String(variantId);
  }

  function applyAvailabilityOverride(variant) {
    if (!variant || !variant.id) return;

    var variantId = String(variant.id);
    var productId = findProductIdForVariant(variantId);
    if (!productId) return;

    var inventoryRecord = getInventoryRecord(productId, variantId);
    if (!inventoryRecord) return;

    var quantity = Number(inventoryRecord.quantity);
    if (!Number.isFinite(quantity)) return;

    var inventoryElements = document.querySelectorAll('[data-product-inventory][data-product-id="' + productId + '"]');
    inventoryElements.forEach(function(element) {
      if (!inventoryBelongsToSelectedVariant(element, variantId)) return;

      element.dataset.variantId = variantId;
      element.dataset.inventoryCount = String(quantity);

      var wrapper = element.parentElement;
      if (wrapper) {
        wrapper.classList.remove('inventory--dodani');
      }

      if (quantity > 0 || variant.available === false) {
        return;
      }

      var text = element.getAttribute('data-availability-override') || element.getAttribute('data-waiting-for-stock');
      if (!text) return;

      if (wrapper) {
        wrapper.classList.remove('inventory--low');
        wrapper.classList.add('inventory--dodani');
      }

      element.textContent = text;
    });
  }

  document.addEventListener('variant:change', function(evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;

    // Impulse emits document variant:change before it finishes updating the
    // master variant input. Run after the current stack so rapid switching
    // always resolves against the latest selected variant in each product UI.
    setTimeout(function() {
      applyAvailabilityOverride(variant);
    }, 0);
  });
})();
